import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { Card, Text } from '@gravity-ui/uikit';
import { block } from '../../utils';
import './TogglerCard.css';
const b = block('toggler-card');
export const TogglerCard = ({ description, title, text, onClick, disabled, selected, }) => {
    return (React.createElement(Card, { onClick: onClick, type: "selection", disabled: disabled ? !selected : disabled, selected: selected, size: "m", className: b() },
        React.createElement("div", { className: b('header') },
            React.createElement(Text, { variant: "subheader-2", ellipsis: true }, title),
            description ? (React.createElement(HelpPopover, { htmlContent: description, placement: ['bottom', 'top'] })) : null),
        React.createElement(Text, { variant: "body-1", color: "secondary", className: b('text') }, text)));
};
